module.exports = __webpack_public_path__ + "static/media/aryan.24d38cea.jpg";